import { useSpring } from "react-spring";
import { CircularButton } from "./CircularButton";
import { bioPink } from "../../constants/constants";
import { springConfigs } from "../../constants/springConfigs";
import { OnCurtainStart, Screen } from "../../types/types";

export const LeftCircleArrow = ({
  onCurtainStart,
  screenLeft,
  screenRight,
}: {
  onCurtainStart: OnCurtainStart;
  screenLeft: Screen;
  screenRight: Screen;
}) => {
  // border animation
  const { animatedOffset } = useSpring({
    from: { animatedOffset: 1 },
    to: { animatedOffset: 0 },
    config: springConfigs.outlineAppear,
  });
  return (
    <CircularButton
      {...{
        animatedOffset,
        color: "white",
        left: true,
        onCurtainStart,
        screenLeft,
        screenRight,
      }}
    />
  );
};
export const RightCircleArrow = ({
  onCurtainStart,
  screenLeft,
  screenRight,
}: {
  onCurtainStart: OnCurtainStart;
  screenLeft: Screen;
  screenRight: Screen;
}) => {
  // border animation
  const { animatedOffset } = useSpring({
    from: { animatedOffset: 1 },
    to: { animatedOffset: 0 },
    config: springConfigs.outlineAppear,
  });
  return (
    <CircularButton
      {...{
        animatedOffset,
        color: bioPink,
        left: false,
        onCurtainStart,
        screenLeft,
        screenRight,
      }}
    />
  );
};

// export const ArrowComponent = ({
//   onCurtainStart,
//   screenLeft,
//   screenRight,
// }: {
//   onCurtainStart: OnCurtainStart;
//   screenLeft: Screen;
//   screenRight: Screen;
// }) => {
//   // border animation
//   const { animatedOffset } = useSpring({
//     from: { animatedOffset: 1 },
//     to: { animatedOffset: 0 },
//     config: springConfigs.outlineAppear,
//   });
//   return (
//     <>
//       <CircularButton
//         {...{
//           animatedOffset,
//           color: "white",
//           left: true,
//           onCurtainStart,
//           screenLeft,
//           screenRight,
//         }}
//       />
//       <CircularButton
//         {...{
//           animatedOffset,
//           color: bioPink,
//           left: false,
//           onCurtainStart,
//           screenLeft,
//           screenRight,
//         }}
//       />
//     </>
//   );
// };
